.c-dropdown {
  display: inline-block;
}

  .c-dropdown .c-dropdown__toggle {
    width: inherit;
    cursor: pointer;
  }

  .c-dropdown__window {
  position: absolute;
  top: 0px;
  left: 0px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;

    z-index: calc(var(--z-index-top) + 1);
}

  .c-dropdown__link a,
    .c-dropdown__link .button_to > [type="submit"],
    .c-dropdown__link button {
  display: block;
  width: 100%;
  text-align: left;
  text-transform: none;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity, 1));
  line-height: 1.25rem;
}

  @media (min-width: 1024px) {

  .c-dropdown__link a,
    .c-dropdown__link .button_to > [type="submit"],
    .c-dropdown__link button {
    white-space: nowrap;
  }
}

  .c-dropdown__link a,
    .c-dropdown__link .button_to > [type="submit"],
    .c-dropdown__link button {
  font-weight: 400;
}

  .c-dropdown__link a:hover, .c-dropdown__link .button_to > [type="submit"]:hover, .c-dropdown__link button:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1)) !important;
}

  .c-dropdown__link a.disabled, .c-dropdown__link .button_to > [type="submit"].disabled, .c-dropdown__link button.disabled {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
  cursor: not-allowed;
}

  .c-dropdown__link button {
  border-radius: 0px;
}

  .c-dropdown__link .button_to {
  display: block;
  width: 100%;
}

/*# sourceMappingURL=data:application/json;base64,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 */